import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as skuMetadataActions from './sku-metadata.actions';
import { of } from 'rxjs';
import { SkuMetadataService } from '@emi/shared/data-access';
import { SkusLastUpdatedDto } from '@emi/shared/models';
import { HttpErrorResponse } from '@angular/common/http';
import { select, Store } from '@ngrx/store';
import { SkuMetadataState } from './sku-metadata.reducer';
import { getSkuMetadataState } from './sku-metadata.selectors';

@Injectable({ providedIn: 'root' })
export class SkuMetadataEffects {

    private skuMetadataState: SkuMetadataState;

    constructor(
        private actions$: Actions,
        private skuMetadataService: SkuMetadataService,
        private skuMetadataStore: Store<SkuMetadataState>) {
        this.skuMetadataStore
            .pipe(select(getSkuMetadataState))
            .subscribe((state) => (this.skuMetadataState = state));
    }

    private fetchSkuMetadata$ = createEffect(() =>
        this.actions$.pipe(
            ofType(skuMetadataActions.fetchSkuMetadata),
            switchMap(() => {

                if (this.skuMetadataState.lastUpdated && this.skuMetadataState.version) {
                    return of(skuMetadataActions.getSkuMetadataSuccess({ lastUpdated: this.skuMetadataState.lastUpdated, version: this.skuMetadataState.version }));
                }

                return this.skuMetadataService.getLastUpdated().pipe(

                    map((skuInfo: SkusLastUpdatedDto) => {
                        return skuMetadataActions.getSkuMetadataSuccess({ lastUpdated: skuInfo.lastUpdated, version: skuInfo.version });
                    }),

                    catchError((error: HttpErrorResponse) => {
                        return of(skuMetadataActions.getSkuMetadataFailure({ error }));
                    })
                );
            })
        )
    );
}
